/* Shared campaign clock: optional cycles use the same absolute anchor for everyone. */
if (!customElements.get('jupityr-campaign-bar')) {
  customElements.define('jupityr-campaign-bar', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.dismissTimer);
      this.resizeObserver?.disconnect();
      if (this.hasAttribute('data-scroll-speed')) {
        this.setupScroll();
        return;
      }
      this.dismissKey = 'dear-jupiter-announcement-dismissed-until';
      const close = this.querySelector('[data-dismiss]');
      if (close) {
        close.hidden = false;
        close.onclick = () => {
          const until = Date.now() + 86400000;
          try { localStorage.setItem(this.dismissKey, String(until)); } catch (_) { /* Closing still works when storage is unavailable. */ }
          this.hideUntil(until);
          document.querySelector('.header__icon--menu')?.focus({ preventScroll: true });
        };
        if (!window.Shopify?.designMode) {
          try {
            const until = Number(localStorage.getItem(this.dismissKey));
            if (until > Date.now() && until <= Date.now() + 86400000) this.hideUntil(until);
          } catch (_) { /* Keep the bar available when storage is blocked. */ }
        }
      }
      this.deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(this.dataset.end || '') ? Date.parse(this.dataset.end) : NaN;
      this.defaultText = this.querySelector('[data-default]');
      this.campaign = this.querySelector('[data-campaign]');
      const cycleHours = Number(this.dataset.cycleHours);
      this.cycle = this.dataset.repeat === 'true' && Number.isFinite(cycleHours) && cycleHours > 0 ? cycleHours * 3600000 : 0;
      if (!Number.isFinite(this.deadline)) return;
      this.update();
      if (this.cycle || this.deadline > Date.now()) this.timer = setInterval(() => this.update(), 1000);
    }
    setupScroll() {
      const messages = this.querySelector('[data-messages]');
      const speed = Math.min(40, Math.max(12, Number(this.dataset.scrollSpeed) || 32));
      if (!messages) return;
      const measure = () => {
        if (!this.isConnected) return;
        this.style.setProperty('--campaign-duration', `${messages.getBoundingClientRect().width / speed}s`);
        this.dataset.ready = 'true';
      };
      measure();
      this.resizeObserver = new ResizeObserver(measure);
      this.resizeObserver.observe(messages);
      document.fonts?.ready.then(measure);
    }
    update() {
      const now = Date.now();
      const nextDeadline = this.cycle && now >= this.deadline
        ? this.deadline + (Math.floor((now - this.deadline) / this.cycle) + 1) * this.cycle
        : this.deadline;
      const remaining = Math.max(0, Math.ceil((nextDeadline - now) / 1000));
      this.defaultText.hidden = remaining > 0;
      this.campaign.hidden = remaining <= 0;
      if (!remaining) { clearInterval(this.timer); return; }
      this.querySelector('[data-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      this.querySelector('[data-minutes]').textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
      this.querySelector('[data-seconds]').textContent = String(remaining % 60).padStart(2, '0');
    }
    hideUntil(until) {
      this.hidden = true;
      clearTimeout(this.dismissTimer);
      this.dismissTimer = setTimeout(() => { this.hidden = false; }, Math.max(0, until - Date.now()));
    }
    disconnectedCallback() { clearInterval(this.timer); clearTimeout(this.dismissTimer); this.resizeObserver?.disconnect(); }
  });
}
